// extracted by mini-css-extract-plugin
export var deleteIcon = "_ob-5";
export var deleteOption = "_ob-3";
export var divider = "_ob-2";
export var downloadIcon = "_ob-4";
export var drawer = "_ob-0";
export var drawerFooter = "_ob-6";
export var drawerOpen = "_ob-1";
export var highlighted = "_ob-7";
export var lighterHighlight = "_ob-8";